import { useParams } from "react-router-dom";
import { ProjectLayout } from "./ProjectLayout";
import { useWorkspaceProjectAnalytics } from "hooks/useWorkspaceProjectAnalytics";

export const ProjectLayoutWrapper = () => {
  const { projectId, workspaceId } = useParams<{ projectId: string; workspaceId: string }>();

  useWorkspaceProjectAnalytics(workspaceId ?? undefined, projectId ?? undefined);

  return <ProjectLayout key={`${workspaceId}-${projectId}`} />;
};
